<template>
  <v-main>
    <v-container fluid>
      <div>
        <v-row class="ml-4"><h2>Funded Projects</h2></v-row>
        <v-data-table
          :dense="true"
          :headers="headers"
          :items="funded"
          item-key="id"
          :height="550"
          hide-default-footer
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>
                <v-avatar><v-icon v-text="item.icon"></v-icon></v-avatar
                >{{ item.text }}
              </td>

              <td class="text-center" >
               <v-img
                class="mx-2"
                :src="getDieSuccess(item)"
                max-height="60"
                contain
                left
              >
              </v-img>
              </td>
              <td class="text-center" >
               <v-img
                class="mx-2"
                :src="getDie(item)"
                max-height="60"
                contain
                left
              >
              </v-img>
              </td>

              <td class="text-center" v-if="item.rolled === ''">
                <v-btn @click="onRoll(item)">Roll</v-btn>
              </td>
              <td class="text-center" v-else>{{ item.rolled }}</td>
              <td class="text-center red--text" v-if="item.rolled === 'Total'">
                <h3>{{ item.result }}</h3>
              </td>
              <td class="text-center" v-else>{{ item.result }}</td>
              <td class="text-center red--text" v-if="item.rolled === 'Total'">
                <h3>{{ item.value }}</h3>
              </td>
              <td class="text-center" v-else>
                <h3>{{ item.value }}</h3>
              </td>
            </tr>
          </template>
          <template slot="body.append">
            <tr class="pink--text">
              <th></th>
              <th></th>
              <th></th>
              <th class="subtitle-1 text-center">Total</th>
              <th class="subtitle-1 text-center">{{ sumSuccesses }}</th>
              <th class="subtitle-1 text-center">{{ sumField("value") }}</th>
            </tr>
          </template>
        </v-data-table>
        <v-row v-if="advanceRoute" class="mr-2">
          <v-spacer></v-spacer>
          <v-btn
            :disabled="getRolls < 5"
            :loading="false"
            color="#418F7B"
            text x-large
            @click="next"
          >
            Next
          </v-btn>
        </v-row>
        <v-row v-else class="mr-2">
          <v-spacer></v-spacer>
          <v-btn v-if="getRolls >= 5" :disabled="true" color="#951B20" text>
            Please Wait For Game to advance
          </v-btn>
        </v-row>
      </div>
    </v-container>
  </v-main>
</template>

<script>
export default {
  data: () => ({
    headers: [
      {
        text: "Project",
        sortable: false,
        value: "projects",
        class: "title"
      },
      {
        text: "Success Dice",
        sortable: false,
        value: "successDice",
        class: "title",
        align: "center"
      },
      {
        text: "Value Dice",
        sortable: false,
        value: "valueDice",
        class: "title",
        align: "center"
      },
      {
        text: "Dice Roll",
        sortable: false,
        value: "diceRoll",
        class: "title",
        align: "center"
      },
      {
        text: "Result",
        sortable: false,
        value: "result",
        class: "title",
        align: "center"
      },
      {
        text: "Value",
        sortable: false,
        value: "value",
        class: "title",
        align: "center"
      }
    ]
  }),
  watch: {
    getRolls: function(newVal, oldVal) {
      if (newVal === 5 && oldVal === 4) this.$store.dispatch("tabulateResults");
    }
  },
  computed: {
    rollSuccesses() {
      let cnt = 0;
      for (const item of this.funded.slice(0, 5)) {
        if (item.result === "Success") {
          cnt++;
        }
      }
      return cnt;
    },
    getRolls() {
      let cnt = 0;
      for (const item of this.funded) {
        if (item.result) cnt++;
      }
      return cnt;
    },
    sumSuccesses() {
      return this.rollSuccesses.toString() + "/" + this.getRolls.toString();
    },
    funded() {
      return this.$store.getters.projects.filter(
        element => element.funded === true
      );
    },
    advanceRoute() {
      return this.$store.getters.advanceRoute(this.$route.path);
    }
  },
  methods: {
    next() {
      this.$store.dispatch("savePortfolio");
      this.$router.push("fundedreview");
    },
    sumField(key) {
      return this.funded.reduce((a, b) => a + (b[key] || 0), 0);
    },

    getDie(item) {
      if (item.points) {
       return require('@/assets/'+item.max_points.toString()+'/'+item.points.toString()+'.png');
      } else {
        return require('@/assets/'+item.max_points.toString()+'/1.png');
      }
    },
    getDieSuccess(item) {
      if (item.points) {
        if (item.text === "Oyster" | item.text === "White Elephant"){
          return require('@/assets/w4/'+item.prob_value.toString()+'.png');
        } else {
          return require('@/assets/b4/'+item.prob_value.toString()+'.png');
        }
      } else {
        if (item.text === "Oyster" | item.text === "White Elephant"){
          return require('@/assets/w4/1.png');
        } else {
          return require('@/assets/b4/1.png');
        }
      }
    },
    onRoll(selection) {
      selection.points =
        Math.floor(Math.random() * (selection.max_points )) + 1;
        // Math.floor(Math.random() * (selection.max_points - 1)) + 1;
      // selection.prob_value = Math.floor(Math.random() * 3) + 1;
      selection.prob_value = Math.floor(Math.random() * 4) + 1;

      if((selection.success===3 && selection.prob_value>1) || (selection.success===1 && selection.prob_value<2)) {
        selection.result = "Success";
        selection.value = selection.points;
        selection.rolled =
          selection.prob_value.toString() +
          "(S)  " +
          selection.points.toString();
      } else {
        selection.rolled =
          selection.prob_value.toString() +
          "(F)  " +
          selection.points.toString();
        selection.result = "Failure";
        selection.value = 0;
      }






      // if (selection.prob_value > selection.success) {
      //   selection.result = "Success";
      //   selection.value = selection.points;
      //   selection.rolled =
      //     selection.prob_value.toString() +
      //     "(S)  " +
      //     selection.points.toString();
      // } else {
      //   selection.rolled =
      //     selection.prob_value.toString() +
      //     "(F)  " +
      //     selection.points.toString();
      //   selection.result = "Failure";
      //   selection.value = 0;
      // }
      this.$store.commit("updateRoll", selection);
    }
  }
};
</script>
